import React from 'react';
import { useQuery } from '../../../utils/helper';
// import { Page } from 'react-pdf';
// import { Document } from 'react-pdf/dist/esm/entry.webpack';
// // import { Document } from 'react-pdf/dist/umd/entry.webpack';
// import { pdfjs } from 'react-pdf';
// pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

class FileViewer extends React.PureComponent {
    constructor(props) {
        super(props);
        const query = useQuery();
        var url = query.get('url');
        //const url = await this.getSpBlob(query.get('url'));
        this.state = {
            blobUrl: url//''//'https://streamrealty.sharepoint.com/sites/AllocationsTest/_layouts/15/download.aspx?UniqueId=649165fb-1062-4584-9b5a-f338b4125206&Translate=false&tempauth=eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAvc3RyZWFtcmVhbHR5LnNoYXJlcG9pbnQuY29tQDcyNDQ2YmU5LWE0NTQtNGJmYS04N2Q0LThjZjRmNmVhYWYzOSIsImlzcyI6IjAwMDAwMDAzLTAwMDAtMGZmMS1jZTAwLTAwMDAwMDAwMDAwMCIsIm5iZiI6IjE2Mjk1NTM4NTEiLCJleHAiOiIxNjI5NTU3NDUxIiwiZW5kcG9pbnR1cmwiOiJLVlJRNlpybXB5eTV1NUovLzFHS2EvZithTkduQVVISERjdmpyWitlMitBPSIsImVuZHBvaW50dXJsTGVuZ3RoIjoiMTQ1IiwiaXNsb29wYmFjayI6IlRydWUiLCJjaWQiOiJNRFkzWVRVd05qWXRNakZoWlMwME5qQmhMVGhtTXpJdFpqaGxZMk16TjJVMU1EQXgiLCJ2ZXIiOiJoYXNoZWRwcm9vZnRva2VuIiwic2l0ZWlkIjoiT0RFeE16VTNaR010TXpSbVpTMDBZemRtTFdGa09HWXRZbU01WTJZMllUaGxNRFkzIiwiYXBwX2Rpc3BsYXluYW1lIjoiRENfREVWX0FQUCIsImdpdmVuX25hbWUiOiJEQ19BZG1pbiIsImFwcGlkIjoiMTE1YjA5ZGEtNjU4Mi00NGZmLThkNTctZTlhNzczODg0YWRjIiwidGlkIjoiNzI0NDZiZTktYTQ1NC00YmZhLTg3ZDQtOGNmNGY2ZWFhZjM5IiwidXBuIjoiZGMuYWRtaW5pc3RyYXRvckBzdHJlYW1kYXRhY2VudGVycy5jb20iLCJwdWlkIjoiMTAwMzIwMDBEMjVCMTIxRCIsImNhY2hla2V5IjoiMGguZnxtZW1iZXJzaGlwfDEwMDMyMDAwZDI1YjEyMWRAbGl2ZS5jb20iLCJzY3AiOiJhbGxzaXRlcy5tYW5hZ2UgYWxsc2l0ZXMucmVhZCBhbGxzaXRlcy53cml0ZSBteWZpbGVzLnJlYWQgYWxsZmlsZXMucmVhZCBteWZpbGVzLndyaXRlIGFsbGZpbGVzLndyaXRlIG15ZmlsZXMucmVhZCBteWZpbGVzLndyaXRlIGFsbHNpdGVzLm1hbmFnZSBhbGxzaXRlcy5yZWFkIGFsbHNpdGVzLndyaXRlIGFsbHByb2ZpbGVzLnJlYWQiLCJ0dCI6IjIiLCJ1c2VQZXJzaXN0ZW50Q29va2llIjpudWxsfQ.Q2ZtNGxrTDQvUURkQkF5a1p2MTFJTmptSjJUWkJDRVZzRU9MYUVSaXNtOD0&ApiVersion=2.0'
        };

        //this.setState({ blobUrl: url })
    }

    async componentDidMount() {
        //const url = await this.getSpBlob('https://streamrealty.sharepoint.com/sites/AllocationsTest/_layouts/15/download.aspx?UniqueId=649165fb-1062-4584-9b5a-f338b4125206&Translate=false&tempauth=eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAvc3RyZWFtcmVhbHR5LnNoYXJlcG9pbnQuY29tQDcyNDQ2YmU5LWE0NTQtNGJmYS04N2Q0LThjZjRmNmVhYWYzOSIsImlzcyI6IjAwMDAwMDAzLTAwMDAtMGZmMS1jZTAwLTAwMDAwMDAwMDAwMCIsIm5iZiI6IjE2Mjk1NTM4NTEiLCJleHAiOiIxNjI5NTU3NDUxIiwiZW5kcG9pbnR1cmwiOiJLVlJRNlpybXB5eTV1NUovLzFHS2EvZithTkduQVVISERjdmpyWitlMitBPSIsImVuZHBvaW50dXJsTGVuZ3RoIjoiMTQ1IiwiaXNsb29wYmFjayI6IlRydWUiLCJjaWQiOiJNRFkzWVRVd05qWXRNakZoWlMwME5qQmhMVGhtTXpJdFpqaGxZMk16TjJVMU1EQXgiLCJ2ZXIiOiJoYXNoZWRwcm9vZnRva2VuIiwic2l0ZWlkIjoiT0RFeE16VTNaR010TXpSbVpTMDBZemRtTFdGa09HWXRZbU01WTJZMllUaGxNRFkzIiwiYXBwX2Rpc3BsYXluYW1lIjoiRENfREVWX0FQUCIsImdpdmVuX25hbWUiOiJEQ19BZG1pbiIsImFwcGlkIjoiMTE1YjA5ZGEtNjU4Mi00NGZmLThkNTctZTlhNzczODg0YWRjIiwidGlkIjoiNzI0NDZiZTktYTQ1NC00YmZhLTg3ZDQtOGNmNGY2ZWFhZjM5IiwidXBuIjoiZGMuYWRtaW5pc3RyYXRvckBzdHJlYW1kYXRhY2VudGVycy5jb20iLCJwdWlkIjoiMTAwMzIwMDBEMjVCMTIxRCIsImNhY2hla2V5IjoiMGguZnxtZW1iZXJzaGlwfDEwMDMyMDAwZDI1YjEyMWRAbGl2ZS5jb20iLCJzY3AiOiJhbGxzaXRlcy5tYW5hZ2UgYWxsc2l0ZXMucmVhZCBhbGxzaXRlcy53cml0ZSBteWZpbGVzLnJlYWQgYWxsZmlsZXMucmVhZCBteWZpbGVzLndyaXRlIGFsbGZpbGVzLndyaXRlIG15ZmlsZXMucmVhZCBteWZpbGVzLndyaXRlIGFsbHNpdGVzLm1hbmFnZSBhbGxzaXRlcy5yZWFkIGFsbHNpdGVzLndyaXRlIGFsbHByb2ZpbGVzLnJlYWQiLCJ0dCI6IjIiLCJ1c2VQZXJzaXN0ZW50Q29va2llIjpudWxsfQ.Q2ZtNGxrTDQvUURkQkF5a1p2MTFJTmptSjJUWkJDRVZzRU9MYUVSaXNtOD0&ApiVersion=2.0');
        const query = useQuery();
        var url = query.get('url');
        //const url = await this.getSpBlob(url1);
        this.setState({ blobUrl: url })
    }

    getSpBlob = (url) => {
        return new Promise(function (resolve, reject) {
            fetch(url)
                .then(response => response.blob())
                .then(function (blob) {
                    const dataUrl = URL.createObjectURL(blob);
                    return resolve(dataUrl);
                }).catch(() => {
                    return resolve('');
                }
                );
        });
    }

    render() {
        return (
            <div>
                { this.state.blobUrl &&
                    <div style={{ width: '100vw', height: '100vh', marginTop: 0 }}>
                        {/* <iframe src={url} width="700" height="700"></iframe> */}
                        {/* <embed src={`data:application/pdf;base64,${url}`} type="application/pdf" width="100%"></embed> */}
                        <iframe
                            id="iframe"
                            scrolling="no"
                            onLoad={(ev) => {
                                const x = document.getElementById('iframe');
                                (((x.contentWindow || {}).document.getElementsByTagName('embed') || [])[0] || {})
                                    .style.height = '900px';
                            }}
                            src={this.state.blobUrl}
                            style={{
                                width: '100%',
                                height: '100%',
                                overflow: 'hidden',
                                display: 'block'
                            }}
                            frameBorder="0"
                            allowFullScreen={true}
                        ></iframe>
                    </div>
                }
            </div>
        );
    }
}
export default FileViewer;
